export class AppointmentRepeat {
    periodicity: number = 7
    weekDays: number[] = []
    quantity: number = 0
}
